// extracted by mini-css-extract-plugin
export default {"your_rd":"tx","title":"ux","subtitle":"vx","rd_bio_wrapper":"wx","rd_text_mobile":"xx","rd_bio":"yx","img":"zx","rd_info":"Ax","rd_name":"Bx","rd_stat":"Cx","rd_text":"Ex","btn_mobile":"Fx"};
    if(module.hot) {
      // 1738836192996
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  